import { render, staticRenderFns } from "./DeerParasites.vue?vue&type=template&id=8badcb18&"
import script from "./DeerParasites.vue?vue&type=script&lang=js&"
export * from "./DeerParasites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports